import { JobPostingServiceApi } from 'mnvm-mypage-app-ts-if'
import { config } from './api-config'

export const jobPostingServiceApi = new JobPostingServiceApi(config)
